import { render, staticRenderFns } from "./RankIcon.vue?vue&type=template&id=8273e170"
import script from "./RankIcon.vue?vue&type=script&lang=js"
export * from "./RankIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports